import mitt, { Emitter } from "mitt";

const emitter: Emitter<any> = mitt<any>();

export function useEmitter(): Emitter<any> {
    return emitter;
}
